export default __webpack_public_path__ + "static/media/birds.7522ca11.png";